import React, {useEffect, useCallback} from 'react';
import { makeStyles } from '@material-ui/styles';
import { Grid } from '@material-ui/core';
import { useSelector,useDispatch } from "react-redux";
import { getUsers, setRowsPerPage, setPage, setOpenUserDialog, getUserData, changeUserData } from '../../redux/reducers/adminReducer';
import { roles } from '../../redux/reducers/appReducer';
import UsersTable from './components/UsersTable/UsersTable';

import { UserDialog } from './components';

const useStyles = makeStyles(theme => ({
    root: {
        height: '100%',
        paddingTop: '140px',
        paddingLeft: theme.spacing(4),
        paddingRight: theme.spacing(4),
        [theme.breakpoints.up('md')]: {
            paddingTop: '70px'
        },
    },
    footer:{
        height: '70vh'
    },
  
}));

const Admin = props => {
    const classes = useStyles();
    
    const { users, rowsPerPage, page, usersCount, userDialog } = useSelector(state => state.adminReducer); 

    const dispatch = useDispatch();

    const stableDispatch = useCallback(args => {
      return dispatch(args)
    }, [dispatch]);

    useEffect(() => {

        stableDispatch(getUsers(page,rowsPerPage));
        
    }, [stableDispatch,page,rowsPerPage]);

    const handleAddUser = () => {
        dispatch(getUserData(-1));
    };

    const handleEditUser = (userId) => {
        dispatch(getUserData(userId));
    };

    const handleCloseUserDialog = () => {
        dispatch(setOpenUserDialog(false));
    };

    const handleChangePage = (event, newPage) => {
       dispatch(setPage(newPage));
      };

      const handleChangeRowsPerPage = (event) => {
        dispatch(setRowsPerPage(parseInt(event.target.value, 10)));
        dispatch(setPage(0));
      };
    
    const handleSaveUserData = (data) => {

        dispatch(changeUserData(data));
    }

    return (
        <div className={classes.root}>
         <Grid container spacing={2}>
            <Grid
                item
                xl={4}
                lg={6}
                md={6}
                sm={12}
                xs={12}
            >   
                            
                <UsersTable
                    users={users}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    usersCount={usersCount}
                    onChangePage={handleChangePage}
                    onChangeRowsPerPage={handleChangeRowsPerPage}
                    onClickAddUser={handleAddUser}
                    onClickEditUser={handleEditUser}
                />
            </Grid>    

         </Grid>
         <div className={classes.footer}></div>
        {userDialog.openUserDialog
        ? <UserDialog
          open={userDialog.openUserDialog}
          onClose={handleCloseUserDialog}
          init={userDialog.userDialogInit}
          isEdit={Boolean(userDialog.userDialogInit)}
          onSaveUserData={handleSaveUserData}
          roles={roles}
          userDialogAlert={userDialog.userDialogMessage}
        />
        : null}

        </div>
    );
};

export default Admin;